import styled from 'styled-components';

const ButtonStyle = styled.div`
	--btnPadTB: var(--sp3x);
	--btnPadLR: var(--sp7x);
	--btnBorderRadius: var(--sp7x);

	--borderRadiusHoverTypeSize: var(--sp2x);

	&.btn {
		width: fit-content;
		/* overflow: hidden; */
		cursor: pointer;

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--btnPadTB) var(--btnPadLR);
			color: var(--green1000);
			font-size: var(--p2);
			font-family: var(--larken);
			font-weight: 400;
			line-height: var(--lineHeightL);
			background-color: transparent;
			border-radius: var(--btnBorderRadius);
			border: 1px solid var(--green1000);

			isolation: isolate;
			backface-visibility: visible;
			overflow: hidden;
			transform: scale(1);
			will-change: transform;
			transition: transform 0.4s ease-out;

			cursor: pointer;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						transform: scale(0.95);
					}
				}
			}
		}

		&.yellow-type {
			a,
			button {
				background-color: var(--yellow1000);
				border: 1px solid var(--yellow1000);
			}
		}

		&.green-type {
			a,
			button {
				background-color: var(--green1000);
				color: var(--white1000);
			}
		}

		&.white-type {
			a,
			button {
				/* background-color: var(--green1000); */
				color: var(--white1000);
				border: 1px solid var(--white1000);
			}
		}

		&.double {
			.content-wrap {
				position: relative;
				overflow: hidden;

				.fake-text {
					position: absolute;
					top: 120%;
					left: 0;
					white-space: nowrap;
					transition: top 0.4s ease-out;
				}

				.real-text {
					position: relative;
					transform: translateY(0);
					transition: transform 0.4s ease-out;
				}
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						.content-wrap {
							.fake-text {
								top: 0;
							}

							.real-text {
								transform: translateY(-120%);
							}
						}
					}
				}
			}
		}

		&.disabled {
			pointer-events: none;

			a,
			button {
				opacity: 0.5;
				pointer-events: none;
				/* color: var(--green100); */
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--btnPadTB: var(--sp2-5x);
		--btnPadLR: var(--sp6x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--btnPadTB: 18px;
		--btnPadLR: var(--sp5x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--btnPadTB: 18px;
		--btnPadLR: var(--sp4x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--btnPadTB: var(--sp2x);
		--btnPadLR: var(--sp4x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--btnPadTB: var(--sp2x);
		--btnPadLR: var(--sp3x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
